import { render, staticRenderFns } from "./ApplicantsSelectionMns.vue?vue&type=template&id=1069dba0&"
import script from "./ApplicantsSelectionMns.vue?vue&type=script&lang=js&"
export * from "./ApplicantsSelectionMns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports